/**
 * Input Component
 * Text input with consistent styling
 */

import React from 'react';

const Input = React.forwardRef(({
  label,
  error,
  required = false,
  disabled = false,
  className = '',
  ...props
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#A0AEC0] mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        ref={ref}
        disabled={disabled}
        className={`w-full px-4 py-2.5 bg-[#0F1218] border border-[#2D3748] rounded-lg text-white placeholder-[#4A5568] transition-all duration-200 focus:outline-none focus:border-[#128C7E] focus:ring-1 focus:ring-[#128C7E] disabled:bg-[#1A1D23] disabled:cursor-not-allowed ${className}`}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
